import { postActivity } from "../api/activityApi";
import postHotel from "../api/hotelApi";
import postFlight from "../api/flightApi";
import { postCar } from "../api/carApi";
import postTransport from "../api/transportApi";
import { updateActivityStepField } from "@services/redux/slices/activitySlice";
import { updateHotelStepField } from "@services/redux/slices/hotelSlice";
import { updateFlightStepField } from "@services/redux/slices/flightSlice";
import { updateCarStepField } from "@services/redux/slices/carSlice";
import { updateTransportStepField } from "@services/redux/slices/transportSlice";
import { updatePackageField } from "@services/redux/slices/packageSlice";
import postPackage from "../api/packageApi";
import { updateRestaurantStepField } from "@services/redux/slices/restaurantSlice";
import postRestaurant from "../api/restaurantApi";
import { updateHostingStepField } from "@services/redux/slices/hostingSlice";
import postHosting from "../api/hostingApi";
import { updateEventStepField } from "@services/redux/slices/eventSlice";
import postEvent from "../api/eventApi";

// --- ACTIONS, API & SELECTORS MAPS ---
export const ACTION_MAP = {
  Activity: updateActivityStepField,
  Hotel: updateHotelStepField,
  Flight: updateFlightStepField,
  Car: updateCarStepField,
  Transport: updateTransportStepField,
  Package: updatePackageField,
  Restaurant: updateRestaurantStepField,
  Hosting: updateHostingStepField,
  Events: updateEventStepField,
};

export const API_FUNCTIONS = {
  Activity: postActivity,
  Hotel: postHotel,
  Flight: postFlight,
  Car: postCar,
  Transport: postTransport,
  Package: postPackage,
  Restaurant: postRestaurant,
  Hosting: postHosting,
  Events: postEvent,
};

export const PRODUCT_SELECTORS = Object.fromEntries(
  Object.keys(ACTION_MAP).map((key) => [
    key,
    (state) => state[key.toLowerCase()],
  ])
);

export const SUPPORTED_PRODUCT_TYPES = Object.keys(API_FUNCTIONS);

// --- STEP LEVEL MAP (where saving occurs) ---
export const STEP_LEVEL_MAP = {
  Activity: { 6: 1, 11: 2, 16: 3 },
  Hotel: { 5: 1, 7: 2, 10: 3 },
  Car: { 6: 1, 11: 2, 16: 3 },
  Flight: { 3: 1, 4: 2, 5: 3, 9: 4 },
  Transport: { 5: 1, 9: 2, 14: 3 },
  Package: { 6: 1, 11: 2, 13: 3, 18: 4 },
  Restaurant: { 5: 1, 9: 2, 15: 3 },
  Hosting: { 5: 1, 9: 2, 14: 3 },
  Events: { 4: 1, 7: 2, 13: 3 },
};

export const getLevelFromStep = (type, step) => {
  const map = STEP_LEVEL_MAP[type];
  if (!map) return null;

  const ends = Object.keys(map)
    .map(Number)
    .sort((a, b) => a - b);
  for (const end of ends) {
    if (step <= end) return map[end];
  }

  // step is beyond last end → return last level
  return map[ends[ends.length - 1]] ?? null;
};
